import { createInjectionKey } from "../../../_utils/vue/create-injection-key.mjs";
export const internalSelectionMenuInjectionKey = createInjectionKey('n-internal-select-menu');
export const internalSelectionMenuBodyInjectionKey = createInjectionKey('n-internal-select-menu-body');